import type { IconSvgObject } from './types';

const PoundSendIcon: IconSvgObject = [
  ["path", { d: "M19 15.5L21.5 13L19 10.5M15 13H20.8912", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M8.5 13C6.01472 13 4 10.9853 4 8.5C4 6.01472 6.01472 4 8.5 4C10.9853 4 13 6.01472 13 8.5M8.5 13H10.5M8.5 13H7.5M14.5 19L14.0077 19.3282C13.3506 19.7662 12.5786 20 11.7889 20H3C6 18 7.5 14.5 7.5 13M2.5 13H7.5", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }]
];

export default PoundSendIcon;
